import styled from "styled-components";

/**
 * Deliberately unmissable but out of the way: fixed to the top centre, above the video window
 * (which is itself portalled to the body and draggable), so it is visible wherever the translator
 * has parked everything else.
 */
export const BadgeSC = styled.div`
    position: fixed;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 14px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.82);
    color: #fff;
    font-size: 13px;
    line-height: 1.2;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
    pointer-events: auto;
`;

export const SkipButtonSC = styled.button`
    border: 1px solid rgba(255, 255, 255, 0.55);
    background: transparent;
    color: #fff;
    border-radius: 4px;
    padding: 3px 9px;
    font-size: 12px;
    cursor: pointer;

    &:hover {
        background: rgba(255, 255, 255, 0.15);
    }
`;
